import {FC} from "react";
import {Box, BoxProps, Typography} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {useTranslation} from "react-i18next";
import type {CourseDetailsDto, GetCourseCurriculumResponse} from "@/app2/shared/data";
import {AdminHeader} from "@/pages/ManagerView/AdminHeader";
import {palette} from "@/constants";

const useStyles = makeStyles()((theme) => ({
	contentBox: {
		marginTop: theme.spacing(3),
		padding: theme.spacing(2.5),
		backgroundColor: palette.greyDark,
		borderWidth: 0,
		borderRadius: theme.borderRadius.small
	},
	hr: {
		borderTop: 0,
		borderColor: theme.palette.grey[100]
	},
	contentContainer: {
		display: "flex",
		"& span": {
			fontWeight: 700
		},
		gap: theme.spacing(3),
		flexDirection: "column"
	}
}));

interface CourseOverviewTabProps {
	course: CourseDetailsDto;
	curriculum?: GetCourseCurriculumResponse;
}

export type IProps = Omit<BoxProps, "children"> & CourseOverviewTabProps;

/**
 * Course Overview Tab
 * 
 * Displays course description and basic information.
 * Matches the design of the original OverviewTab.
 */
export const CourseOverviewTab: FC<IProps> = ({course, curriculum, ...baseProps}) => {
	const {classes} = useStyles();
	const {t} = useTranslation();

	return (
		<Box {...baseProps}>
			<Box className={classes.contentBox}>
				<AdminHeader title={t("course_overview_title")} />
				<Box className={classes.contentContainer}>
					{course ? (
						<>
							<Typography variant="body1">{course.description}</Typography>
							<hr className={classes.hr} />
							<Typography variant="body1">
								<span>{t("course_overview_number_of_lessons")}</span> {curriculum?.totalItems ?? course.totalLessons}
							</Typography>
							{/* <Typography variant="body1"><span>Course Duration:</span> </Typography> */}
						</>
					) : null}
				</Box>
			</Box>
		</Box>
	);
};
